import classNames from 'classnames';
import { TabPane as TabPaneComponent } from 'rc-tabs';
import { useEffect, useRef } from 'react';

const TabPane = ({ children, active, className, ...props }) => {
  const ref = useRef();

  useEffect(() => {
    if (active) {
      ref.current.scrollTo(0, 0);
    }
  }, [active]);

  return (
    <TabPaneComponent active={active} {...props} destroyInactiveTabPane>
      <div ref={ref} className={classNames('tab-pane-content overflow', className)}>
        {children}
      </div>
    </TabPaneComponent>
  );
};

export default TabPane;
